// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3QKg8","inputWrap":"CustomTip_inputWrap__1TELH"};